module.exports = __webpack_public_path__ + "img/realizar-diagnostico.341cc814.svg";